import type { RemoteName } from "../../mfe/mfeConfig";
import type { CurrentMfe } from "./state";
import type { MfeRouteConfig } from "./types";
import { matchPath } from "./utils";

export const matchPathToMfe = (
  path: string,
  mfesConfig: Record<RemoteName, MfeRouteConfig>
) =>
  Object.values(mfesConfig).reduce<CurrentMfe | null>(
    (previousMatch, mfeConfig) => {
      const matchingPath = mfeConfig.paths.find((mfeRoute) =>
        matchPath(mfeRoute, path)
      );

      if (matchingPath) {
        /**
         * If the path is an exact match we should prioritise it.
         * e.g. given that the current path is `/foo`, `/foo` is more
         * exact that `foo/*`
         */
        const isPreviousExactMatch =
          previousMatch && previousMatch.path === path;
        const isCurrentExactMatch = matchingPath === path;

        /**
         * We assume that given a path `/foo/bar`, a matching MFE with
         * `/foo/bar` is more favorable than a MFE with just `/foo/*`, but if
         * there was a previous match on `/`, we don't want the fallback `/*`
         * to override it.
         **/
        const isLongerThanPrevious =
          previousMatch && matchingPath.length > previousMatch.path.length;
        /**
         * but if there was a previous match on the root path `/`, we don't want the fallback (`/*`) to override it.
         **/
        const isFallback = matchingPath === "/*";

        if (
          !previousMatch ||
          (!isPreviousExactMatch && isCurrentExactMatch) ||
          (isLongerThanPrevious && !isFallback)
        ) {
          return { ...mfeConfig, path: matchingPath };
        }
      }

      return previousMatch;
    },
    null
  );
